// Libs
import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { useHistory, useLocation } from 'react-router';
import { useComponentsPool } from '../../ComponentsPool';
import { useDispatch, useSelector } from 'react-redux';
import useWosCredentials from '../authentication/useWosCredentials';
// Actions
import { getRounds } from './actions';
import RoundsProvider from "./RoundsContext";
import { DEFAULT_ROUND_VIEW } from "./constants";

const splittedUrl = window.location.hostname.split('.');
const URL_SUFFIX = splittedUrl[splittedUrl.length - 1] === 'io' ? 'io' : 'com';
const WOS_URL = `https://wos.merciyanis.${URL_SUFFIX}/jobs`;

const Rounds = () => {
  const iframeRef = React.useRef(null);
  useWosCredentials(iframeRef, WOS_URL);
  const { Component } = useComponentsPool();
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const workspaceSettings = useSelector(state => state.workspace.settings);
  const isNewRoundsView = workspaceSettings.jobs_version === 'NEW';


  useEffect(() => {
    if (!isMobile && !location.search.includes('view=list')) { // By default, we redirect to the calendar view
      const searchParams = new URLSearchParams(location.search);
      searchParams.set('view', DEFAULT_ROUND_VIEW);
      history.push({ search: `?${searchParams}` });
    } else if (location.search.includes('view=list')) {
      dispatch(getRounds(true));
    }
  }, []);

  const iframeKey = new URLSearchParams(location.search).get('_refresh');

  const buildJobsIframeUrl = (baseUrl, params) => {
    const url = new URL(`${baseUrl}/jobs`);
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) url.searchParams.set(key, value);
    });
    return url.toString();
  };

  if (isMobile) {
    if (isNewRoundsView) {
      return <RoundsProvider>
        <iframe
          ref={iframeRef}
          className="clocking-in-jobs-view-wrapper"
          src={buildJobsIframeUrl(
            'https://wos.merciyanis.' + URL_SUFFIX,
            {})
          }
          style={{ width: '100%', height: 'calc(100svh - 56px - 48px)', border: 'none' }}
        />
      </RoundsProvider>
    }

    return <Component componentName={'MobileRoundsView'} />;
  }

  return (
    <RoundsProvider>
      {isNewRoundsView
        ? <iframe
          ref={iframeRef}
          key={iframeKey} // refresh the iframe when the refresh param is changed
          src={buildJobsIframeUrl(
            'https://wos.merciyanis.' + URL_SUFFIX,
            {
              job: new URLSearchParams(window.location.search).get('job'),
            })
          }
          style={{ width: '100%', height: '100%', border: 'none' }}
        />
        : <Component componentName={'RoundsTable'} />
      }
    </RoundsProvider>
  );
};

export default React.memo(Rounds);
